module.exports = __webpack_public_path__ + "public/images/slider/ferdman.c4c1e36d101e72111de86cb1a4ca20db.webp";